import { request } from "../client"

export type RegistryArchiveBatchSkip = {
  target_id: string
  reason: "already_archived" | "already_active" | "building_unit" | "parent_archived" | string
}

export type RegistryArchiveBatchFailure = {
  target_id: string
  reason: string
}

export type RegistryArchiveBatchResponse = {
  requested_count: number
  processed_count: number
  skipped_count: number
  failed_count: number
  processed_ids: string[]
  skips: RegistryArchiveBatchSkip[]
  failures: RegistryArchiveBatchFailure[]
}

type RegistryArchiveTarget = "property" | "property_unit" | "customer"

const targetIdField = (target: RegistryArchiveTarget) => `${target}_id`

export const archiveRegistryRoots = (
  endpoint: string,
  target: RegistryArchiveTarget,
  ids: string[],
  reason: ArchiveReason = "USER_REQUEST",
) =>
  request<RegistryArchiveBatchResponse>(endpoint, {
    method: "POST",
    body: JSON.stringify({
      items: ids.map((id) => ({ [targetIdField(target)]: id })),
      reason,
    }),
  })

export const restoreRegistryRoots = (
  endpoint: string,
  target: RegistryArchiveTarget,
  ids: string[],
) =>
  request<RegistryArchiveBatchResponse>(endpoint, {
    method: "POST",
    body: JSON.stringify({
      items: ids.map((id) => ({ [targetIdField(target)]: id })),
    }),
  })
